import "./ContactForm.scss";

const ContactForm = () => {
  return (
    <div className="contact-form__container">
      <div className="contact-form__header">
        <h2 className="contact-form__title">Let's Collaborate</h2>
        <p className="contact-form__subtitle">
          Interested in working together? I'm always open to discussing new
          projects and opportunities.
        </p>
      </div>

      <form
        className="contact-form__form"
        action={`https://getform.io/f/${process.env.REACT_APP_PORTFOLIO_GET_FORM_ID}`}
        method="POST"
      >
        <div className="contact-form__field">
          <label htmlFor="name">Name</label>
          <input
            id="name"
            className="contact-form__input"
            name="name"
            placeholder="John Doe"
            required
          />
        </div>

        <div className="contact-form__field">
          <label htmlFor="email">Email</label>
          <input
            id="email"
            className="contact-form__input"
            name="email"
            type="email"
            placeholder="john@example.com"
            required
          />
        </div>

        <div className="contact-form__field">
          <label htmlFor="project">Project Type</label>
          <select
            id="project"
            className="contact-form__input"
            name="project_type"
            required
          >
            <option value="">Select a project type</option>
            <option value="website">Website Development</option>
            <option value="webapp">Web Application</option>
            <option value="frontend">Frontend Development</option>
            <option value="consulting">Technical Consulting</option>
            <option value="other">Other</option>
          </select>
        </div>

        <div className="contact-form__field">
          <label htmlFor="message">Message</label>
          <textarea
            id="message"
            className="contact-form__input contact-form__textarea"
            name="message"
            placeholder="Tell me about your project..."
            required
          ></textarea>
        </div>

        <button type="submit" className="contact-form__button">
          Send Message
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M5 12h14M12 5l7 7-7 7" />
          </svg>
        </button>
      </form>
    </div>
  );
};

export default ContactForm;
